import { EGDSSpacing } from '@egds/react-core/spacing';
import { inject } from 'mobx-react';
import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { PropertyReviews } from '@shared-ui/lodging-reviews';
import { RefTarget } from '@shared-ui/ref-context';
import { useDialog } from '@shared-ui/dialog-context';
import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { SharedUiPropertyReviewsDialog } from './shared-ui-property-reviews-dialog';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
export const sharedUIReviewsDialog = 'sui-see-all-reviews-dialog';
export const SharedUiPropertyReviewsWrapper = inject('currentHotel', 'context')(({
  currentHotel,
  context
}) => {
  var _a, _b;
  const propertyId = (_a = currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.hotelId) === null || _a === void 0 ? void 0 : _a.toString();
  const isDated = ((_b = currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.searchCriteria) === null || _b === void 0 ? void 0 : _b.startDate) && currentHotel.searchCriteria.startDate.length > 0;
  const searchCriteria = context && currentHotel && adaptSearchCriteria(context, currentHotel.searchCriteria);
  const [, dialogActions] = useDialog(sharedUIReviewsDialog, 'pwaDialog');
  const input = React.useMemo(() => {
    if (!propertyId) {
      return null;
    }
    return {
      propertyId,
      pagination: {
        size: 10,
        startingIndex: 0
      },
      includeRecentReviews: isDated,
      searchCriteria
    };
  }, [propertyId, isDated, searchCriteria]);
  if (!input) {
    return null;
  }
  const onSeeAllReviewsLinkClick = () => {
    dialogActions.openDialog();
  };
  return React.createElement(ErrorBoundary, {
    label: "hotel.information.reviews"
  }, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(RefTarget, {
    name: "Reviews"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyReviews, {
    inputs: input,
    onClickLink: onSeeAllReviewsLinkClick,
    hideManagementResponse: true
  }), React.createElement(SharedUiPropertyReviewsDialog, {
    dialogType: sharedUIReviewsDialog
  })))));
});
SharedUiPropertyReviewsWrapper.displayName = 'SharedUiPropertyReviewsWrapper';